import { render, staticRenderFns } from "./FeePreview.vue?vue&type=template&id=dcf3fe32"
import script from "./FeePreview.vue?vue&type=script&lang=js"
export * from "./FeePreview.vue?vue&type=script&lang=js"
import style0 from "./FeePreview.vue?vue&type=style&index=0&id=dcf3fe32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports